import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './HeroBanner.styles';

const media = (path: string) =>
  staticMediaUrl(`landing/bioderma-hydrabio/${path}`);

/** Первый экран Hydrabio */
export function HeroBanner() {
  const slots = styles();

  return (
    <section className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.woman()}>
          <picture>
            <source
              srcSet={media('banner-woman-mobile2.jpg')}
              media="(max-width: 1023px)"
            />
            <img
              className={slots.womanImage()}
              src={media('banner/banner-woman.jpg')}
              alt=""
              width={711}
              height={424}
              fetchPriority="high"
            />
          </picture>
          <img
            className={slots.logoRecommend()}
            src={media('logo-recommend-mobile.png')}
            alt=""
            width={150}
            height={72}
          />
          <p className={slots.hoursMobile()}>
            72<span className={slots.hoursMobileUnit()}>ч</span>
            <span className={slots.hoursMobileLabel()}>
              увлажнения<sup>2</sup>
            </span>
          </p>
          <p className={slots.technologyMobile()}>
            Технология активации увлажнения+
          </p>
        </div>

        <p className={slots.titleDesktop()}>
          <span className={slots.titleBig()}>
            hydrabio
            <br />
          </span>
          <span className={slots.titleSmall()}>наука увлажнения кожи</span>
        </p>

        <div className={slots.products()}>
          <img
            className={slots.productsImage()}
            src={media('banner-products2.png')}
            alt=""
            width={272}
          />
        </div>

        <div className={slots.info()}>
          <div className={slots.videoWrap()}>
            <video
              className={slots.video()}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source
                src={media('banner/texture.mp4')}
                type="video/mp4"
              />
            </video>
            <p className={slots.videoText()}>
              раскройте потенциал
              <br /> вашей кожи
            </p>
            <img
              className={slots.videoLogo()}
              src={media('banner/banner-logo.png')}
              alt=""
              width={251}
              height={32}
            />
          </div>
          <p className={slots.technology()}>Технология активации увлажнения+</p>
          <p className={slots.hours()}>
            <span className={slots.hoursBig()}>72ч</span>
            <span className={slots.hoursSmall()}>
              увлажнения<sup>2</sup>
            </span>
          </p>
          <img
            className={slots.circle()}
            src={media('banner/circle.png')}
            alt=""
          />
        </div>

        <p className={slots.titleMobile()}>
          <span className={slots.titleBigMobile()}>
            hydrabio
            <br />
          </span>
          <span className={slots.titleSmallMobile()}>
            наука увлажнения кожи
          </span>
        </p>
      </div>
    </section>
  );
}
